var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2343 13.12C11.8676 14.06 10.9743 14.6667 9.96763 14.6667H6.0343C5.02096 14.6667 4.1343 14.06 3.76763 13.12C3.40096 12.1733 3.6543 11.1267 4.40096 10.4467L7.10096 8H8.90763L11.601 10.4467C12.3476 11.1267 12.5943 12.1733 12.2343 13.12Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2351 2.88065C11.8684 1.94065 10.9751 1.33398 9.9684 1.33398H6.03507C5.0284 1.33398 4.13507 1.94065 3.7684 2.88065C3.4084 3.82732 3.65507 4.87398 4.4084 5.55398L7.10173 8.00065H8.9084L11.6017 5.55398C12.3484 4.87398 12.5951 3.82732 12.2351 2.88065ZM9.21507 4.82065H6.7884C6.53507 4.82065 6.33507 4.61398 6.33507 4.36732C6.33507 4.12065 6.54173 3.91398 6.7884 3.91398H9.21507C9.4684 3.91398 9.6684 4.12065 9.6684 4.36732C9.6684 4.61398 9.46173 4.82065 9.21507 4.82065Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.18f1de7604559cedee1b084ec0412cf0.svg";
export { ForwardRef as ReactComponent };